module.exports = __webpack_public_path__ + "static/media/saxophone.871eb8d4.svg";